// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"3a32c941","442":"3a32c941","696":"f92c610e","783":"3a32c941","957":"3a32c941"}[chunkId] + ".chunk.css";
};